import {needAuth} from "../instance/Instance";
import {userLogout} from "../auth/AuthService";
import {getToken} from "../../components/commonmethod/CommonMethod";

const BASE_URL = import.meta.env.VITE_BASE_URL;

async function getFile(file) {
    const token = getToken();
    const downloadName = file?.originalName || file?.uploadName || "download";

    try {
        const response = await fetch(BASE_URL + "/file/download", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({id: file?.id, ...file}),
        });

        if (!response.ok) {
            throw new Error(`download failed: ${response.status}`);
        }

        const contentType = response.headers.get("content-type") || "";
        const blob = await response.blob();

        if (!blob.size || contentType.includes("application/json")) {
            throw new Error("empty download response");
        }

        saveBlobAsFile(blob, downloadName);
    } catch (error) {
        console.error("파일을 다운로드하는 동안 오류가 발생했습니다:", error);
        window.alert("파일을 다운로드할 수 없습니다.");
    }
}

async function fetchFileBlob(file) {
    const token = getToken();
    const response = await fetch(BASE_URL + "/file/download", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({id: file?.id, ...file}),
    });

    if (!response.ok) {
        throw new Error(`download failed: ${response.status}`);
    }

    const contentType = response.headers.get("content-type") || "";
    const blob = await response.blob();

    if (!blob.size || contentType.includes("application/json")) {
        throw new Error("empty download response");
    }

    return blob;
}

function filenameFromContentDisposition(disposition, fallback = "excel-template.xlsx") {
    if (!disposition) return fallback;
    const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
    if (match?.[1]) return match[1].replace(/['"]/g, "");
    return fallback;
}

function saveBlobAsFile(blob, fileName) {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}

async function readBlobAsJson(blob) {
    const text = await blob.text();
    return JSON.parse(text);
}

/**
 * 엑셀 양식 다운로드 — POST `/excel/sample/{entityName}`
 * @param {string} entityName
 * @param {object} excelHeader `getHeadersForSetting` 응답 body (`Map<String, List<ColumnDto>>`)
 */
async function getExcelSample(entityName, excelHeader) {
    const response = await needAuth.post(`/excel/sample/${entityName}`, excelHeader, {
        responseType: "blob",
        headers: {"Content-Type": "application/json"},
    });

    const contentType = String(response.headers["content-type"] ?? "");

    if (response.status === 202 || contentType.includes("application/json")) {
        const data = await readBlobAsJson(response.data);
        alert(`${data?.title ?? "오류"}\n${data?.reason ?? ""}`);
        return;
    }

    const fileName = filenameFromContentDisposition(
        response.headers["content-disposition"],
    );
    saveBlobAsFile(response.data, fileName);
}


async function newUploadExcel(excel, entityName){
    const formData = new FormData();
    formData.append("file", excel);
    return await needAuth.post(`/excel/new-upload/${entityName}`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
}

async function newSaveExcel(entityName, map) {
    console.log(map)
    return await needAuth.post(`/excel/new-update/default`, JSON.stringify(map), {
        headers: {
            "Content-Type": "application/json",
        },
    });
}

async function newSaveExcelForUpload(entityName, map) {
    console.log(map)
    return await needAuth.post(`/excel/new-update/upload`, JSON.stringify(map), {
        headers: {
            "Content-Type": "application/json",
        },
    });
}


async function downLoadExcel(map) {
    const token = getToken();
    let header ;
    if(token != null){
        header = {
            'Content-Type': 'application/json',
            'Authorization' : `Bearer ${token}`
        }
    }else{
        alert("로그인 세션이 만료되어 로그아웃 되었습니다(1).")
        const response = await userLogout();
        window.location.replace("/");
        return response;
    }
    return fetch(BASE_URL + `/excel/download`, {
        method: 'Post',
        headers: header,
        body: JSON.stringify(map),
    })
        .then((response) => {
            if (response.status === 202) {
                return response.json().then((data) => {
                    alert(data.title + "\n" + data.reason);
                });
            }
            if (response.ok) {
                const disposition = response.headers.get('Content-Disposition');
                let fileName = 'downloaded-file.xlsx';
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                return response.blob().then((blob) => ({blob, fileName}));
            }
            throw new Error('파일 다운로드 실패: ' + response.statusText);
        })
        .then((result) => {
            if (!result) return;
            const {blob, fileName} = result;
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch((error) => console.error('파일 다운로드 중 오류 발생:', error));
}


async function getDataList(entityName, search) {
    return await needAuth.post(`/excel/select-data/${entityName}`,  JSON.stringify(search), {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}


async function deleteImagesAndFiles(fileId){
    try {
        const response = await needAuth.delete(`/file/delete?id=`+fileId);
        return response.status;
    } catch (error) {
        return error;
    }
}

async function deleteFileById(fileId) {
    try {
        return await needAuth.delete(`/file/delete?id=${fileId}`);
    } catch (error) {
        return error;
    }
}

async function findFileByJoinKey(tableName, joinKey, types = []) {
    for (const type of types) {
        try {
            const response = await getImagesAndFiles(tableName, joinKey, type);
            if (response?.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
                return response.data[0];
            }
        } catch (error) {
            // 다음 type 시도
        }
    }
    return null;
}

async function findFileIdByJoinKey(tableName, joinKey, types = []) {
    const file = await findFileByJoinKey(tableName, joinKey, types);
    return file?.id ?? null;
}

async function findUserPortraitFile(userId) {
    return findFileByJoinKey("user", userId, ["PORTRAIT", "IMG"]);
}

async function findUserPortraitFileId(userId) {
    const file = await findUserPortraitFile(userId);
    return file?.id ?? null;
}

async function findUserSignFileId(userId) {
    return findFileIdByJoinKey("user", userId, ["SIG", "SIGN"]);
}

async function uploadImagesAndFiles(images, files, uploader){

    const formData = new FormData();
    Array.from(images).forEach(img => {
        formData.append(`images`, img);
    });

    Array.from(files).forEach(file => {
        formData.append(`files`, file);
    });

    formData.append(
        "SimmsFileRequestDto",
        new Blob([JSON.stringify(uploader)], { type: "application/json" })
    );

    try {
        const response = await needAuth.post(`/file/upload`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
        return response.status;
    } catch (error) {
        return error;
    }
}

// DB에 저장하지 않고 실제 파일만 업로드
// partName 이 서버 저장 파일명을 결정한다 (logo -> logo.png, menuLogo -> menu_logo.png)
async function postLogo(file, partName){
    const formData = new FormData();
    Array.from(file).forEach(logo => {
        formData.append(partName, logo);
    });

    formData.append(
        "SimmsFileRequestDto",
        new Blob([JSON.stringify({})], { type: "application/json" })
    );

    try {
        const response = await needAuth.post(`/file/upload`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
        return response.status;
    } catch (error) {
        return error;
    }
}

// 로그인 화면용 로고 (어두운 배경)
async function uploadLogo(file){
    return postLogo(file, `logo`);
}

// 사이드바/헤더용 로고 (밝은 배경)
async function uploadMenuLogo(file){
    return postLogo(file, `menuLogo`);
}

async function uploadPortraitImages(images, uploader, target){

    const formData = new FormData();
    Array.from(images).forEach(img => {
        formData.append(`images`, img);
    });

    formData.append(
        "SimmsFileRequestDto",
        new Blob([JSON.stringify(uploader)], { type: "application/json" })
    );
    try {
        return await needAuth.post(`/file/upload/portrait`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
    }catch (error){
        return error;
    }
}

async function uploadImageSign(userId, name, blob) {
    const file = new File([blob], name + '_sig.png', { type: 'image/png' });
    const tableInfo={tableName : "user", joinKey : userId}
    const formData = new FormData();
    formData.append(`sig`, file);
    formData.append('SimmsFileRequestDto',  new Blob([JSON.stringify(tableInfo)],{ type: "application/json" }));

    return needAuth.put('/file/upload/sign', formData)

}

async function getImagesAndFiles(tableName, joinKey, type){

    try {
        const response = await needAuth.get(`/file/get?tableName=`+tableName+`&joinKey=`+joinKey+`&type=`+type);
        return response;
    } catch (error) {
        return error;
    }
}


async function parseExcelFile(excel, entityName, mode){
    const formData = new FormData();
    formData.append("file", excel);
    return await needAuth.post(`/excel/parse/${entityName}/${mode}`, formData, {headers : {'Content-Type': 'multipart/form-data'}});
}


async function refreshExcel(entityName){
    console.log("엑셀 헤더초기화")
    return await needAuth.get(`/excel/refresh/${entityName}`);
}

async function clearExcel(){
    console.log("엑셀 헤더초기화")
    return await needAuth.get(`/excel/clear`);
}

async function getHeadersForSetting(entityName){
    console.log("엑셀 헤더 조회")
    return await needAuth.get(`/excel/setting/${entityName}`);
}


async function validation(entityName, map, mode){
    console.log(map)

    return await needAuth.post(`/excel/validation/${entityName}/${mode}`,  JSON.stringify(map), {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}


async function uploadExcel(entityName, map){
    console.log("엑셀 데이터 업로드")

    return await needAuth.post(`/excel/upload/${entityName}`,  JSON.stringify(map), {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

async function updateExcelFile(entityName, map){
    console.log("엑셀 데이터 수정 업로드")

    return await needAuth.post(`/excel/update/${entityName}`,  JSON.stringify(map), {
        headers: {
            'Content-Type': 'application/json',
        }
    });
}


export{
    getFile,
    fetchFileBlob,
    getDataList,
    deleteImagesAndFiles,
    deleteFileById,
    findUserPortraitFile,
    findUserPortraitFileId,
    findUserSignFileId,
    uploadImagesAndFiles,
    getImagesAndFiles,
    parseExcelFile,
    uploadImageSign,
    updateExcelFile,
    getExcelSample,
    refreshExcel,
    clearExcel,
    getHeadersForSetting,
    validation,
    downLoadExcel,
    uploadExcel,
    newUploadExcel,
    newSaveExcel,
    newSaveExcelForUpload,
    uploadPortraitImages,
    uploadLogo,
    uploadMenuLogo
};